import { createSlice } from "@reduxjs/toolkit";

const authSlice = createSlice({
    name: 'auth',
    initialState: {},
    reducers: {
        setUser: (state, action) => {
            state.user = action.payload
        },
        setSession: (state, action) => {
            state.session = action.payload
        }
    }
})

export const { setUser, setSession } = authSlice.actions;

export default authSlice;